/**
 * @file Revelation animee d'un tirage : cartes qui se retournent une a une, couleur et lueur du meilleur grade ; toucher pour continuer.
 */
import { gradeIndex } from '@shared/enums';
import { Component } from '../../core/Component';
import { clear, h } from '../../core/dom';
import type { UiContext } from '../../UiContext';
import { createTile } from './tile';

/** A partir de ce grade (S), le tirage est "gagnant" : lueur + fond colore. */
const BIG_WIN_INDEX = 4;
const STEP_S = 0.12;

export class GachaReveal extends Component {
  private cards!: HTMLElement;
  private title!: HTMLElement;

  constructor(ctx: UiContext) {
    super(ctx, 'div', 'reveal is-hidden');
  }

  protected build(): void {
    const t = this.ctx.i18n;
    this.el.setAttribute('data-ui-block', '');
    this.title = h('h3', { class: 'reveal-title outlined-text' }, t.t('weapons.drawResult'));
    this.cards = h('div', { class: 'reveal-cards' });
    this.el.append(this.title, this.cards, h('p', { class: 'hint reveal-hint' }, t.t('weapons.tapToClose')));
    this.on(this.el, 'pointerdown', () => this.hide());
  }

  /** Affiche le resultat d'un tirage (defIds dans l'ordre du tirage). */
  show(defIds: readonly string[]): void {
    clear(this.cards);
    let best = 0;
    defIds.forEach((id, i) => {
      const def = this.ctx.index.weapon(id);
      const gi = gradeIndex(def.grade);
      best = Math.max(best, gi);
      const front = createTile(this.ctx, def, 'reveal-tile').root;
      const card = h(
        'div',
        { class: `reveal-card${gi >= BIG_WIN_INDEX ? ' big' : ''}` },
        h('div', { class: 'reveal-face back' }, '?'),
        h('div', { class: 'reveal-face front' }, front, h('div', { class: 'reveal-name' }, this.ctx.i18n.name(def.name))),
      );
      card.style.setProperty('--i', String(i));
      card.style.setProperty('--delay', `${(0.15 + i * STEP_S).toFixed(2)}s`);
      this.cards.append(card);
    });
    this.el.classList.toggle('single', defIds.length === 1);
    this.el.classList.toggle('big-win', best >= BIG_WIN_INDEX);
    this.el.classList.remove('is-hidden');
  }

  hide(): void {
    this.el.classList.add('is-hidden');
    clear(this.cards);
  }

  get visible(): boolean {
    return !this.el.classList.contains('is-hidden');
  }
}
